import { render, staticRenderFns } from "./_my_bets.vue?vue&type=template&id=7688a4f4&lang=pug&"
import script from "./_my_bets.vue?vue&type=script&lang=js&"
export * from "./_my_bets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports